import { ConfirmModal as Component } from "../../../components/organisms/modal/ConfirmModal";

type Props = {
  value: string;
  title: string;
  actionLabel?: string;
  cancelLabel?: string;
  isOpen: boolean;
  isLoading: boolean;
  closeModal: () => void;
  onChangeClick: () => void;
};

export const ConfirmModal = ({
  value,
  title,
  actionLabel = "はい",
  cancelLabel = "いいえ",
  isLoading,
  closeModal,
  onChangeClick,
  isOpen,
}: Props) => {
  return (
    <Component
      isLoading={isLoading}
      isOpen={isOpen}
      title={title}
      value={value}
      actionLabel={actionLabel}
      cancelLabel={cancelLabel}
      onChangeClick={onChangeClick}
      closeModal={closeModal}
    />
  );
};
